import { useTranslation } from 'react-i18next';

const Testimonial = () => {
  const { t } = useTranslation('common');
  const testimonials = (t('testimonial.items', { returnObjects: true }) || []).map((it, idx) => ({ id: idx + 1, ...it }));

  return (
    <section className="bg-cream py-16 lg:py-24">
      <div className="container mx-auto px-8 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-2">{t('testimonial.title')}</h2>
          <p className="text-base text-text-dark">{t('testimonial.subtitle')}</p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-6">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="group bg-white rounded-lg p-6 shadow-sm border border-transparent transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-brown/30"
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <svg 
                  className="w-8 h-8 text-brown transition-transform duration-300 group-hover:scale-110" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-10zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z"/>
                </svg>
              </div>

              {/* Quote Text */}
              <p className="text-sm text-text-dark leading-relaxed mb-6">
                {testimonial.quote}
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-3">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:rotate-1"
                />
                <div>
                  <h4 className="font-semibold text-base text-text-dark mb-1">
                    {testimonial.name}
                  </h4>
                  {/* Star Rating */}
                  <div className="flex gap-0.5 transition-opacity duration-300 group-hover:opacity-100">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <svg key={i} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#fbaa33" className="transition-transform duration-300 group-hover:scale-110">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
